import { render, staticRenderFns } from "./ModalDownload.vue?vue&type=template&id=3b0023c8"
import script from "./ModalDownload.vue?vue&type=script&lang=js"
export * from "./ModalDownload.vue?vue&type=script&lang=js"
import style0 from "./ModalDownload.vue?vue&type=style&index=0&id=3b0023c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ac4a2b9949c4313c2020f7aba7a6f905/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports